






import mixins from 'vue-typed-mixins';
import { PageModeMixin } from '@/main/mixins/pageMode';
import { mapActionsDvm } from '@/main/pages';
import { PageInfo } from '@/main/store/pageManager';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { ZAKAZKA_DRUH } from '@/modules/servis/zakazka/constants';
import { OperationsMixin } from '@/main/mixins/operations';

import { store } from '../../store/edit';

export default mixins(PageModeMixin, OperationsMixin).extend({
	name: 'SlevaInputNumer',
	props: {
		value: { type: String, default: '' },
		precision: { type: Number, default: 2 },
		labelKey: { type: String, required: true },
		suffixText: { type: String, default: '%' },
		storeUri: { type: String, default: null, required: true },
		zpracujEnabled: { type: Boolean, default: false },
	},
	computed: {
		...genVuexComputeds(store),
		sleva: {
			get(this: any) {
				return (this.edit !== null) ? this.edit[this.value] : null;
			},
			set(this: any, value) {
				if (this.edit !== null) this.edit[this.value] = value;
			},
		},
		isProdejZapujDrSlz(): boolean {
			return this.ZakazkaDruh! === ZAKAZKA_DRUH.ZAPUJCKA
				|| this.ZakazkaDruh! === ZAKAZKA_DRUH.PRODEJ_ZBOZI
				|| this.ZakazkaDruh! === ZAKAZKA_DRUH.DROBNE_SLUZBY;
		},
	},
	watch: {
		sleva() {
			this.recalulateCount();
		},
	},
	methods: {
		...mapActionsDvm(store.actions),
		recalulateCount() {
			// this.slevaChange(); // TP1-TODO: volani BE pri zmene slevy pro prepocet finalni ceny
		},
	},
});
